import { render, staticRenderFns } from "./StockFailLayer.vue?vue&type=template&id=a1516826&"
import script from "./StockFailLayer.vue?vue&type=script&lang=ts&"
export * from "./StockFailLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports